window.freeShippingMessageUpdate = async () => {
  const result = await fetch("/browsing_context_suggestions.json");
  const data = await result.json();
  
  if (data) {
    const initialUsShippingMsg = document.querySelectorAll(
      ".free-shipping-initial-message.us-shipping"
    );
    const initialCaShippingMsg = document.querySelectorAll(
      ".free-shipping-initial-message.ca-shipping"
    );
    const initialOtherShippingMsg = document.querySelectorAll(
      ".free-shipping-initial-message.other-shipping"
    );
    const usShippingThreshold = document
      .querySelector(".site-header")
      .getAttribute("data-us-shipping-threshold");
    const caShippingThreshold = document
      .querySelector(".site-header")
      .getAttribute("data-ca-shipping-threshold");
    const otherShippingThreshold = document
      .querySelector(".site-header")
      .getAttribute("data-other-shipping-threshold");

    const usCustomerInitialFreeShippingMessage = document.querySelectorAll(
      ".free-shipping__us-customer--initial.us-customer-shipping"
    );
    const usCustomerLoggedInFreeShippingMessage = document.querySelectorAll(
      ".free-shipping__us-customer--logged-in.us-customer-shipping"
    );
    const isCustomerLoggedIn = usCustomerLoggedInFreeShippingMessage.length > 0;
    if (data.detected_values.country.handle === "US") {
      if (window.theme.settings.usCustomersShippingMessage) {
        if (!isCustomerLoggedIn)
          [...usCustomerInitialFreeShippingMessage].forEach(message =>
            message.classList.remove("hidden")
          );
        if (isCustomerLoggedIn)
          [...usCustomerLoggedInFreeShippingMessage].forEach(message =>
            message.classList.remove("hidden")
          );
      } else {
        handleShippingMessage(initialUsShippingMsg, usShippingThreshold, true);
      }
    } else if (data.detected_values.country.handle === "CA") {
      handleShippingMessage(initialCaShippingMsg, caShippingThreshold, false);
    } else {
      handleShippingMessage(
        initialOtherShippingMsg,
        otherShippingThreshold,
        false
      );
    }
  }
};

handleShippingMessage = (
  initialShippingMessage,
  shippingThreshold,
  currencyText
) => {
  const cartTotalPrice =
    parseInt(
      document
        .querySelector(".site-header")
        .getAttribute("data-cart-total-price")
    ) / 100;

  const awayShippingMsg = document.querySelectorAll(
    ".free-shipping-away-message"
  );
  const finalShippingMsg = document.querySelectorAll(".free-shipping-success");

  if (cartTotalPrice === 0) {
    Array.from(initialShippingMessage).forEach(item => {
      item.style.display = "block";
    });
  } else if (cartTotalPrice > 0) {
    if (cartTotalPrice > parseInt(shippingThreshold)) {
         console.log("ies")
      Array.from(finalShippingMsg).forEach(item => {
        item.style.display = "block";
      });
    } else {
         console.log("else")
      let awayShipping = (parseInt(shippingThreshold) - cartTotalPrice).toFixed(
        2
      );
      let awayShippingCurrency = `USD`;
      // let cookieCurrency = Currency.cookie.read();
      let cookieCurrency = 'USD';
      if (cookieCurrency === "CAD") {
        awayShipping = Currency.convert(awayShipping, "USD", "CAD").toFixed(2);
        awayShippingCurrency = "CAD";
      }
      var checkCheckbox = document.querySelector("body").getAttribute('data-checkCurrency');
      console.log("checkCheckbox",checkCheckbox)
      if(checkCheckbox == 'true'){
           Array.from(awayShippingMsg).forEach(item => {
        console.log("item",item)
        item.querySelector(
          ".away-money"
        ).innerHTML = `$${awayShipping} ${awayShippingCurrency}`;
        item.style.display = "block";
      });
      }
      else{
        Array.from(awayShippingMsg).forEach(item => {
          console.log("item",item)
          item.querySelector(
            ".away-money"
          ).innerHTML = `$${awayShipping}`;
          item.style.display = "block";
        });
      }
    }
  }

  if (currencyText) {
    Array.from(initialShippingMessage).forEach(item => {
      item.querySelector(".money").innerText = item
        .querySelector(".money")
        .innerText.replace("USD", "");
    });
    Array.from(awayShippingMsg).forEach(item => {
      item.querySelector(".away-money").innerText = item
        .querySelector(".away-money")
        .innerText.replace("USD", " ");
    });
  }
};

document.addEventListener("DOMContentLoaded", function () {
  freeShippingMessageUpdate();
});
